import { render, staticRenderFns } from "./FacilityDistributionTab.vue?vue&type=template&id=4108502c&scoped=true"
import script from "./FacilityDistributionTab.vue?vue&type=script&lang=js"
export * from "./FacilityDistributionTab.vue?vue&type=script&lang=js"
import style0 from "./FacilityDistributionTab.vue?vue&type=style&index=0&id=4108502c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4108502c",
  null
  
)

export default component.exports